import React from 'react';
import { Header } from './Header';
import PropTypes from 'prop-types';
import Tabs from './Tabs';
//import { InfoMessage } from 'sharedComponents/InfoMessage';
import { NotificationStatusBar } from './NotificationStatusBar';
import { AssetAndPowertrainFilter } from './AssetAndPowertrainFilter';
import './style.scss';

const DetailedInformationComponent = ({ model, actions }) => {
    const { asset, selectedNotification, nameplatePicturesLoadingStatus } = model;
    function renderTabContent() {
        /* if (asset.isUserAccessible) {
             return <Tabs model={model} actions={actions} />;
         }
         return (
             <div className='pt-asset-permission-error'>
                 <InfoMessage
                     title='ABB.Powertrain.Frontend.detailedInformationPermissionErrorTitle'
                     text='ABB.Powertrain.Frontend.detailedInformationPermissionErrorText'
                 />
             </div>
         );*/
        return <Tabs model={model} actions={actions} />;
    }

    function renderDetailedInformationContent() {
        if (!asset) {
            console.log('Asset not found');
            return;
        }
        return (
            <>
                <NotificationStatusBar />
                <Header asset={asset} selectedNotification={selectedNotification} nameplatePicturesLoadingStatus={nameplatePicturesLoadingStatus} />
                {renderTabContent()}
            </>
        );
    }

    return (
        <div className='pt-detailed-information-container'>
            <AssetAndPowertrainFilter />
            <div className='details-wrapper'>
                <div className='detailed-information-content'>
                    {renderDetailedInformationContent()}
                </div>
            </div >
        </div >
    );
};

DetailedInformationComponent.propTypes = {
    model: PropTypes.shape({
        asset: PropTypes.object,
        selectedNotification: PropTypes.object,
        nameplatePicturesLoadingStatus: PropTypes.string
    }).isRequired,
    actions: PropTypes.object.isRequired
};

export default DetailedInformationComponent;
